import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import {
  FormsModule,
  FormControl,
  Validators,
  FormGroup
} from '@angular/forms';
import {
  TemporaryUrlService,
  AuthenticationService,
  LoadingService,
  EqualValidator,
  regExps,
  errorMessages,
  UserService
} from '../_shared';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: [
    './reset-password.component.css',
    '../../assets/css/core-login.css',
    '../../assets/css/login.css'
  ]
})
export class ResetPasswordComponent implements OnInit {
  changePassForm: FormGroup;
  private isPathValid: boolean;
  private token: string;

  private notifErrorModal = false;
  private notifSuccessModal = false;
  private globalErrorMessages: Object = null;
  private errors = errorMessages;
  public errorMessages: string = null;
  public successMessage: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private temporaryUrlService: TemporaryUrlService,
    private loadingService: LoadingService,
    private authenticationService: AuthenticationService,
    private userService: UserService
  ) {}

  ngOnInit() {
    const token = this.activatedRoute.snapshot.paramMap.get('token');
    this.token = token;
    let data = {
      token: token
    };
    this.temporaryUrlService.isPathValid(data).then(res => {
      console.log(res);
      console.log(res.success);

      if (!res.success) {
        this.authenticationService.setIsFirstTime(true);
        this.authenticationService.logout();
        this.router.navigate(['/expired']);
      } else {
        this.authenticationService.logout();
        this.load(false);
      }
    });

    this.changePassForm = new FormGroup(
      {
        newPasswordControl: new FormControl(null, [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20),
          Validators.pattern(regExps.password)
        ]),
        confirmPasswordControl: new FormControl(null, [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20)
        ])
      },
      {
        validators: EqualValidator.Match(
          'newPasswordControl',
          'confirmPasswordControl'
        )
      }
    );
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  reset() {
    const resetForm = this.changePassForm.value;
    let data = {
      token: this.token,
      new_password: resetForm.newPasswordControl,
      confirm_password: resetForm.confirmPasswordControl
    };
    if (!this.changePassForm.invalid) {
      this.load(true);
      this.userService.changePassword(data).subscribe(res => {
        this.load(false);
        if (res.success) {
          this.successMessage = res.data;
          this.notifSuccessModal = true;
          setTimeout(() => {
            this.router.navigate(['/']);
          }, 3000);
        } else {
          if (res.errors == 'link_expired') {
            this.router.navigate(['/expired']);
          }
          this.errorMessages = res.errors;
          this.notifErrorModal = true;
        }
      });
    }
  }

  closeNotifModal() {
    this.notifErrorModal = false;
    this.notifSuccessModal = false;
    this.errorMessages = null;
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/reset-password/reset-password.component.ts